"use strict";
(self.webpackChunkdemel_shopify_template = self.webpackChunkdemel_shopify_template || []).push([
  [532], {
    6956: (t, e, n) => {
      n.r(e), n.d(e, {
        ProductForm: () => o
      });
      var i = n(4412),
        r = n(2908),
        s = n(1438);
      class o extends HTMLElement {
        constructor() {
          super(), this.form = void 0, this.submitButton = void 0, this.error = !1, this.form = (0, i.U2)("form", this), this.submitButton = (0, i.U2)('[type="submit"], [data-submit]', this), (0, r.p)("submit", this.form, this.onSubmitHandler.bind(this))
        }
        onSubmitHandler(t) {
          if (t.preventDefault(), this.submitButton && "true" === this.submitButton.getAttribute("aria-disabled")) return;
          if( this.submitButton ) {
            this.submitButton.setAttribute("aria-disabled", "true"), this.submitButton.classList.add("loading");
          }
          if( this.form ){
            const e = new FormData(this.form);
            s.Xq(e).then((t => {
              if (t.status) return console.error({
                description: t.description,
                status: t.status
              }), void (this.error = !0);
              this.error = !1, "/cart" === window.location.pathname ? window.location.reload() : MiniBasket.show()
            })).catch((t => {
              console.error(t)
            })).finally((() => {
              if( this.submitButton ) {
                this.submitButton.classList.remove("loading"), this.error || this.submitButton.removeAttribute("aria-disabled")
              }
            }))
          }
        }
      }
      customElements.define("product-form", o)
    },
    2908: (t, e, n) => {
      function i(t, e, n, i) {
        return e || (e = document), e.addEventListener(t, n, i), () => e.removeEventListener(t, n, i)
      }
      n.d(e, {
        p: () => i
      })
    },
    8692: (t, e, n) => {
      n.d(e, {
        N: () => r
      });
      class i {
        constructor(t = "") {
          this.eventTarget = void 0, this.eventTarget = document.appendChild(document.createComment(t))
        }
        on(t, e) {
          this.eventTarget.addEventListener(t, e)
        }
        once(t, e) {
          this.eventTarget.addEventListener(t, e, {
            once: !0
          })
        }
        off(t, e) {
          this.eventTarget.removeEventListener(t, e)
        }
        emit(t, e) {
          return this.eventTarget.dispatchEvent(new CustomEvent(t, {
            detail: e
          }))
        }
      }
      const r = new i("Demel - Event Bus")
    },
    1438: (t, e, n) => {
      n.d(e, {
        J8: () => c,
        Xq: () => a,
        hJ: () => o,
        lb: () => s
      });
      var i = n(4412),
        r = n(8692);

      function s({
        cents: t
      }) {
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: window.Shopify.currency.active
        }).format(t / 100)
      }
      async function o() {
        const t = await fetch("/cart?view=ajax").then((t => t.json()));
        r.N.emit("propify:cart:update", t);
        const e = (0, i.go)(".js-cart-count");
        for (const n of e) n.setAttribute("data-count", `${t.itemCount || ""}`);
        return t
      }
      async function a(t) {
        let e;
        const n = {};
        return t instanceof FormData ? e = t : (e = JSON.stringify(t), n["Content-Type"] = "application/json"), await fetch("/cart/add.js", {
          method: "POST",
          headers: n,
          body: e
        }), o()
      }
      async function c(t) {
        return await fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(t)
        }), o()
      }
    }
  }
]);